import { request } from './http';

export async function getQuarterlyDLQOR(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.filter) {
      queryParams.append('filter', JSON.stringify(params.filter));
    }
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.select) queryParams.append('select', params.select);
    
    return request(`/data/QuarterlyDLQOR?${queryParams.toString()}`);
  }

export async function createQuarterlyDLQOR(dlqorData) {
    return request('/data/QuarterlyDLQOR', {
      method: 'POST',
      body: JSON.stringify(dlqorData)
    });
  }

export async function updateQuarterlyDLQOR(id, dlqorData) {
    return request(`/data/QuarterlyDLQOR/${id}`, {
      method: 'PUT',
      body: JSON.stringify(dlqorData)
    });
  }

export async function deleteQuarterlyDLQOR(id) {
    return request(`/data/QuarterlyDLQOR/${id}`, {
      method: 'DELETE'
    });
  }

export async function getColorimeterCalibrationVerification(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.filter) {
      queryParams.append('filter', JSON.stringify(params.filter));
    }
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.select) queryParams.append('select', params.select);
    
    return request(`/data/colorimeter-logs?${queryParams.toString()}`);
  }

export async function createColorimeterCalibrationVerification(verificationData) {
    return request('/data/ColorimeterLogs', {
      method: 'POST',
      body: JSON.stringify(verificationData)
    });
  }

export async function updateColorimeterCalibrationVerification(id, verificationData) {
    return request(`/data/ColorimeterLogs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(verificationData)
    });
  }

export async function deleteColorimeterCalibrationVerification(id) {
    return request(`/data/ColorimeterLogs/${id}`, {
      method: 'DELETE'
    });
  }

export const quarterlyDlqorApi = {
  getQuarterlyDLQOR,
  createQuarterlyDLQOR,
  updateQuarterlyDLQOR,
  deleteQuarterlyDLQOR,
  getColorimeterCalibrationVerification,
  createColorimeterCalibrationVerification,
  updateColorimeterCalibrationVerification,
  deleteColorimeterCalibrationVerification,
};

